import { render, staticRenderFns } from "./AppMessages.vue?vue&type=template&id=26302710&scoped=true&"
import script from "./AppMessages.vue?vue&type=script&lang=js&"
export * from "./AppMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26302710",
  null
  
)

export default component.exports